import SidebarSecondStatuses from '../resources/enums/SidebarSecondStatuses';

export const status = (PublishTo: Date | null, PublishFrom: Date | null) => {
    const actualData = new Date().setHours(0, 0, 0, 0);
    const publishTo = PublishTo ? new Date(PublishTo).setHours(0, 0, 0, 0) : null;
    const publishFrom = PublishFrom ? new Date(PublishFrom).setHours(0, 0, 0, 0) : null;
    if (publishFrom !== null && publishFrom <= actualData && (publishTo == null || publishTo >= actualData))
        return SidebarSecondStatuses.active;
    else if (publishFrom == null && publishTo == null) return SidebarSecondStatuses.draft;
    else if (publishTo != null && publishTo < actualData) return SidebarSecondStatuses.archived;
    else if (publishFrom != null && publishFrom > actualData) return SidebarSecondStatuses.pending;
    return 'Unknown';
};
